import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

import AuthContext from '../../context/auth/authContext';
import Select from 'react-select';

const UnasignRoleModal = ({ show, handleClose, role }) => {
    const { removeRole, listUsersByRole, role_users } = useContext(AuthContext);

    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        if (role) {
            listUsersByRole(role.roleCode);
        }
    }
        , []);

    const handleAssign = () => {
        if (selectedUser) {
            removeRole(selectedUser.value, role.roleCode);
            handleClose();
        }
    };



    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Un Assign Role: {role?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Select User</Form.Label>
                        <Select
                            options={role_users.map((user) => ({
                                value: user.userCode,
                                label: `${user.name} ${user.payrollNumber}`,
                            }))}
                            onChange={setSelectedUser}
                            placeholder="Choose a user..."
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleAssign} disabled={!selectedUser}>
                    Remove Role from User
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UnasignRoleModal;
